import * as React from "react";
import type { SVGProps } from "react";
const SvgStarFullFill = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M16.22 21.65c.32.23.69.35 1.06.35s.75-.12 1.07-.36c.62-.47.87-1.24.62-1.98l-1.79-5.21 4.01-2.59c.66-.43.96-1.22.74-1.97-.23-.76-.92-1.27-1.72-1.27h-4.65l-1.87-5.43c-.25-.73-.91-1.2-1.69-1.2s-1.44.47-1.69 1.2L8.44 8.62H3.79c-.81 0-1.5.51-1.72 1.27-.22.75.08 1.54.74 1.97l4.01 2.6-1.79 5.21c-.25.74-.01 1.51.62 1.98a1.8 1.8 0 0 0 2.13 0L12 18.58z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgStarFullFill;
